import { InstrumentSpecificType } from './InstrumentSpecificType';
export const CONTINUOUS_CONTRACT_POSTFIX = '_C';
export const INTERIOR_ID_SEPARATOR = ':';
export class InteriorIdUtils {
    static generateInteriorIDWithoutRoute(tradableId, instrumentSpecificType) {
        var _a;
        const tradableIdStr = (_a = tradableId === null || tradableId === void 0 ? void 0 : tradableId.toString()) !== null && _a !== void 0 ? _a : '';
        if (instrumentSpecificType === InstrumentSpecificType.ContinuousContract) {
            return tradableIdStr + CONTINUOUS_CONTRACT_POSTFIX;
        }
        return tradableIdStr;
    }
    static generateInteriorID(instrumentId, tradableId, instrumentSpecificType, route, instrumentSaveMode = false) {
        const interiorIdWithoutRoute = InteriorIdUtils.generateInteriorIDWithoutRoute(tradableId, instrumentSpecificType);
        const interiorIdWithRoute = interiorIdWithoutRoute + INTERIOR_ID_SEPARATOR + route;
        if (instrumentSpecificType === InstrumentSpecificType.ContinuousContract) {
            return instrumentSaveMode ? interiorIdWithRoute + '|' + instrumentId : interiorIdWithRoute;
        }
        return interiorIdWithRoute;
    }
    static parseInteriorID(interiorId) {
        if (!isValidString(interiorId)) {
            return {
                instrumentTradableID: null,
                routeId: null,
                id: null,
                instrumentSpecificType: null
            };
        }
        const splitedName = interiorId.split(INTERIOR_ID_SEPARATOR);
        if (splitedName.length !== 2) {
            return {
                instrumentTradableID: null,
                routeId: null,
                id: null,
                instrumentSpecificType: null
            };
        }
        const instrumentTradableID = parseInt(splitedName[0].split(CONTINUOUS_CONTRACT_POSTFIX)[0], 10);
        const routeId = parseInt(splitedName[1], 10);
        let id = null;
        let instrumentSpecificType = null;
        const continuousSplit = splitedName[1].split('|');
        if (continuousSplit.length > 1) {
            id = parseInt(continuousSplit[1], 10);
            instrumentSpecificType = InstrumentSpecificType.ContinuousContract;
        }
        return {
            instrumentTradableID,
            routeId,
            id,
            instrumentSpecificType
        };
    }
    static removeInstrumentIdFromInteriorID(interiorId, id, instrumentSpecificType) {
        if (isValidNumber(id) && instrumentSpecificType === InstrumentSpecificType.ContinuousContract) {
            return interiorId.replace('|' + id, '');
        }
        return interiorId;
    }
}
